/**
 * Password rules for an admin's own account.
 *
 * The checks run as you type and every one is shown, satisfied or not — a strength meter that only
 * says "weak" leaves the operator guessing which rule they have missed. The server hashes with
 * Argon2id; nothing here is security, it is only the explanation.
 */

export interface PasswordCheck {
  label: string;
  ok: boolean;
}

export const MIN_PASSWORD_LENGTH = 12;

export function passwordChecks(password: string, confirmation: string): PasswordCheck[] {
  return [
    { label: `At least ${MIN_PASSWORD_LENGTH} characters`, ok: password.length >= MIN_PASSWORD_LENGTH },
    { label: 'One uppercase and one number', ok: /[A-Z]/.test(password) && /[0-9]/.test(password) },
    { label: 'One symbol', ok: /[^A-Za-z0-9]/.test(password) },
    { label: 'Both new passwords match', ok: password.length > 0 && password === confirmation },
  ];
}

export function passwordReady(checks: readonly PasswordCheck[]): boolean {
  return checks.every((c) => c.ok);
}
